export interface ImageSourceSelection {
  /** 지금 로드할 단일 URL. */
  targetSrc: string;
  /** targetSrc 가 thumbnail 인지 (= 비동기 생성 대기로 error 시 backoff 재시도 대상). */
  useThumbnail: boolean;
  /** thumbnail 을 포기하고 원본 src 로 낙착됐는지. */
  isFallback: boolean;
}

/**
 * 표시할 단일 소스를 결정하는 순수 함수.
 *
 * - thumbnail 이 있고 아직 소진되지 않았으면 thumbnail 을 우선한다.
 * - thumbnail 이 없거나 재시도가 소진되면 원본 src 로 낙착한다 (isFallback=true).
 *
 * React/시간/I-O 에 의존하지 않으므로 단위 테스트가 쉽다.
 */
export function selectImageSource(args: {
  src: string;
  thumbnailSrc: string | undefined;
  exhausted: boolean;
}): ImageSourceSelection {
  const useThumbnail = !!args.thumbnailSrc && !args.exhausted;
  return {
    targetSrc: useThumbnail ? (args.thumbnailSrc as string) : args.src,
    useThumbnail,
    isFallback: !useThumbnail,
  };
}
